import React from "react";
import { Task } from "../types";

export const TaskHeader: React.FC<{ task: Task }> = ({ task }) => {
    return (
        <div className="mb-4 pb-4 border-b border-slate-200">
            <div className="flex items-center gap-2 text-sm text-slate-500">
                <p>ID: {task.id}</p>
                {task.user && (
                    <>
                        <span className="text-slate-300">•</span>
                        <p>
                            <i className="fas fa-user text-[10px] mr-1" />
                            {task.user.name}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};
